/**
 * Verbatim mirror of Unity's GameConstants.cs strings used in waitlist
 * dialogs. Every v2 waitlist dialog MUST read from this file so the
 * wording stays in lockstep with Unity. Tests assert each constant
 * matches what Unity renders.
 *
 * Unity source: unity/Assets/Scripts/Constants/GameConstants.cs
 */

// Leave-waitlist confirm (TablesView.cs:1708, :2623; MenuForTablesView.cs:430)
export const LEAVE_WAITLIST_TITLE = 'Leaving the Waitlist?';
export const REMOVE_WAITLIST_MESSAGE =
  'Are you sure you want to be removed from the waitlist?';
export const REMOVE_WAITLIST_BUTTON = 'Exit Waitlist';
export const STAY_WAITLIST_BUTTON = 'Close';

// TableDetailView.cs:177 — hard-coded variant with different strings
export const TABLE_DETAIL_WAITLIST_TITLE = 'Waitlisting';
export const TABLE_DETAIL_REMOVE_BUTTON = 'Remove from Waitlist';

// Join-waitlist failed (TablesView.cs:1763)
export const WAITLIST_TITLE = 'Waitlisting';
export const ERROR_MESSAGE =
  'An unexpected error occurred.\nTry again later or contact customer support.';
export const CLOSE_BUTTON = 'Close';

// Maximum tables reached (UICashGame.cs:240, UITableWaitListPreview.cs:239,
// LobbiesViewPortraitAdapter.cs:378, LobbiesViewCellChildAdapter.cs:912)
export const TABLE_LIMIT_TITLE = 'Reached Table Limit';
export const MAXIMUM_TABLES_REACHED_MESSAGE =
  'You must exit another active table or waitlist to join.';
export const MAXIMUM_TABLES_REACHED_MESSAGE_NO_WAITLIST =
  'You must exit another active table to join.';
export const OKAY_BUTTON = 'Okay';

// AutoSeat nothing-selected (AutoSeatView.cs:57)
export const AUTOSEAT_NOTHING_SELECTED_TITLE = 'Waitlisting';
export const AUTOSEAT_NOTHING_SELECTED_MESSAGE =
  'You did not select anything. Nothing will happen.';
